



































































































import {Component, Vue, Prop, Watch} from 'vue-property-decorator';
import {
  Action,
  Getter,
} from 'vuex-class';

@Component
export default class DlgSubscriptionsEdit extends Vue {
  public $refs!: {
    form: any,
  };

  @Prop({type: Object, default: null}) private subscription!: any;
  @Action('admin/subscriptions/update') private updateSubscription!: any;
  @Action('admin/subscriptions/read') private readSubscriptions!: any;
  @Getter('common/rules/all') private rules!: any;
  @Getter('admin/animals/all') private animals!: any;

  private localSubscription: any = null;
  private dialog: boolean = false;
  private loading: boolean = false;
  private valid: boolean = true;

  private menu1: boolean = false;

  @Watch('dialog')
  private onDialogChanged(val: boolean) {
    if (val) {
      this.localSubscription = JSON.parse(JSON.stringify(this.subscription));
      this.localSubscription.entry_date = this.localSubscription.entry_date.substr(0, 10);
    }
  }

  private async update() {
    if (this.$refs.form.validate()) {
      this.loading = true;
      this.localSubscription.entry_date = this.localSubscription.entry_date + ' 00:00:00';
      const success = await this.updateSubscription(this.localSubscription);
      this.localSubscription.entry_date = this.localSubscription.entry_date.substr(0, 10);

      if (success) {
        this.$emit('done');
        this.dialog = false;
        this.localSubscription = null;
        this.$refs.form.resetValidation();
      }

      this.loading = false;
    }
  }

}
